import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';

import Icon from '@components/Icon';
import * as S from './styles';

const PROJECT_PATH = '/projekte/';

const menuItems = [
  {
    id: 1,
    icon: <Icon icon='project' size={24} />,
    text: 'Projekten',
    path: '/projekte'
  }
];

const menuSubItems = [
  {
    id: 1,
    text: 'Kindergarten',
    path: '/kindergarten'
  },
  {
    id: 3,
    text: 'Unterstufe',
    path: '/unterstufe'
  },
  {
    id: 4,
    text: 'Mittelstufe',
    path: '/mittelstufe'
  }
];

const projectItems = [
  {
    id: 1,
    icon: <Icon icon='project' size={24} />,
    text: 'Standorte',
    path: 'standorte'
  },
  {
    id: 2,
    icon: <Icon icon='klassen' size={24} />,
    text: 'Klassen',
    path: 'klassen'
  },
  {
    id: 3,
    icon: <Icon icon='qr_code_scanner' size={24} />,
    text: 'QR Code',
    path: 'qr-code'
  },
  {
    id: 4,
    icon: <Icon icon='sus' size={24} />,
    text: 'SuS',
    path: 'sus'
  },
  {
    id: 5,
    icon: <Icon icon='einteilung' size={24} />,
    text: 'Einteilung',
    path: 'einteilung'
  },
  {
    id: 6,
    icon: <Icon icon='karte' size={24} />,
    text: 'Karte',
    path: 'karte'
  }
];

interface Props {
  isMenuOpen: boolean
}

const SideList = ({ isMenuOpen }: Props) => {
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const isProjectActive = window.location.pathname.includes(PROJECT_PATH);

  const isActive = (path: string): boolean => {
    return window.location.pathname === path || window.location.pathname.includes(`${path}`);
  };

  return (
    <>
      <S.StyledList>
        {isProjectActive ?
          projectItems.map((item) => (
            <S.StyledListItem
              key={item.id}
              className={isActive(item.path) ? 'active' : ''}
              onClick={() => navigate(`/projekte/${id}/${item.path}`)}
            >
              <S.StyledLink to={`/projekte/${id}/${item.path}`}>
                <S.IconWrap className='icon'>
                  {item.icon}
                </S.IconWrap>
                <ListItemText primary={item.text} />
              </S.StyledLink>
            </S.StyledListItem>
          ))
          :
          menuItems.map((item) => (
            <S.StyledListItem
              key={item.id}
              className={isActive(item.path) ? 'active' : ''}
              onClick={() => {
                setOpen(false);
                navigate(item.path);
              }}
            >
              <S.StyledLink to={item.path}>
                <S.IconWrap className='icon'>
                  {item.icon}
                </S.IconWrap>
                <ListItemText primary={item.text} />
              </S.StyledLink>
            </S.StyledListItem>)
          )}
      </S.StyledList>

      {!isProjectActive && <S.AccordionWrap
        className={menuSubItems.some(e => isActive(e?.path)) ? 'active' : ''}
        expanded={open}>

        <S.AccordionHeader
          onClick={() => setOpen(!open)}
          {...(isMenuOpen && { expandIcon: <span className='icon'><Icon icon='chevron-down' size={18} /></span> })}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className='accordion-header'>
            <S.IconWrap className='icon'>
              <Icon icon='book' size={24} />
            </S.IconWrap>
            <ListItemText primary='Standorte' />
          </div>
        </S.AccordionHeader>

        <S.AccordionText>
          <S.StyledList>
            {menuSubItems.map((item) => (
              <S.StyledListItem
                key={item.id}
                className={isActive(item.path) ? 'active' : ''}
                onClick={() => navigate(item.path)}
              >
                <S.StyledLink to={item.path}>
                  <ListItemText primary={item.text} />
                </S.StyledLink>
              </S.StyledListItem>)
            )}
          </S.StyledList>
        </S.AccordionText>
      </S.AccordionWrap>}
    </>
  );
};

export default SideList;
